/**
 * Created by dreamc_t on 2017/4/7.
 */
require('./sportMatch.scss');
var tmpl = require('./sportMatch.ejs');
var tmplMatchInfo = require('./matchInfo.ejs');
var tmplSupport = require('./support.ejs');

// 本地接口http://10.21.7.47:8099   线上http://api.livesports.ifeng.com
var apiDomain = '//api.livesports.ifeng.com';
var requestUrl = apiDomain + '/livesports/match/info'; // 志疆-通过赛事id获取赛事信息接口
var supportGetUrl = apiDomain + '/livesports/survey/surveyres'; // 投票获取接口
var supportPostUrl = apiDomain + '/livesports/survey/vote'; // 投票提交接口


var sportMatch = function (info, message, container) {
    this.info = info;
    this.message = message;
    this.container = container;
    this.initEventSta = false;
};
sportMatch.prototype.updateVote = function (fn, params, polling) {
    // 轮询获取，更新----or----提交返回，更新
    var self = this;
    var vote = Promise.resolve(self[fn](params));
    vote.then(function (data) {
        // console.log('dingshi--getvote--data-succes-', data);
        if (data && data.code == 0) {
            self.updateVoteNum(data);
        } else {
            throw new Error(data.message);
        }
    }).catch(function (e) {
        // console.log('updatevote--data-catch-', e);
    }).finally(function () {
        polling && self.setTimeForVote(); // 轮询
    })
}
sportMatch.prototype.changeScore = function (datas) {
    if (datas.code == 1) {
        var last = this.sportMatchInfo;
        this.sportMatchInfo = Object.assign({}, last, datas.data.data);
        var datanew = this.formatData(this.sportMatchInfo);

        // 重渲染
        this.el.find('.match-info').html($(tmplMatchInfo({ data: datanew })));
        // 广告图, 替换 (上一次存在，则替换，不存在，则新增)
        datas.data.data.ad && this.el.find('.ad img').attr('src', datanew.ad || '//p0.ifengimg.com/508df9aec9e2a/image/2018/05/28/15274917903605_240_80.png');
        // sid更新
        if (datas.data.sid && datas.data.sid !== last.sid) {
            this.updateVote('requestVote', {});
        }
    } else {
        throw new Error(datas.msg || '有广播，但无数据返回');
    }
}
sportMatch.prototype.postVote = function (postParams) {
    return $.ajax({
        url: supportPostUrl,
        type: 'post',
        data: postParams,
        cache: true,
        dataType: 'jsonp'
    })
}
sportMatch.prototype.updateVoteNum = function (data) {
    const option = data.data.resultArray.option;
    this.el.find('.ht .support-num').html(option[0].num || 0);
    this.el.find('.vt .support-num').html(option[1].num || 0);
    // 支持率进度
    const widthHt = this.getPercent(option[0].num, option[1].num);
    this.el.find('.bar-progress').width(widthHt);
    if (this.sportMatchInfo.ad) {
        this.el.find('.ad').css('left', widthHt);
    }
}
sportMatch.prototype.getPercent = function (left, right) {
    var widthHt = '50%';
    var total = left + right;
    if (total !== 0) {
        var percent = Number.parseFloat(left / total).toFixed(2) * 100;
        widthHt = percent + '%';
    }
    return widthHt;
}
sportMatch.prototype.formatData = function (data) {
    data.ad = data.ad || '//p0.ifengimg.com/508df9aec9e2a/image/2018/05/28/15274917903605_240_80.png';// 默认足球
    Object.keys(data).forEach(function (key) {
        // 主客队logo
        if ((key == 'ha' || key == 'va') && data[key]) {
            let url = data[key];
            if (url.indexOf('d.ifengimg.com') == -1) {
                let temp = url.split('/');
                temp[1] = '/d.ifengimg.com/w80_h80';
                url = temp.join('/');
            }
            data[key] = url;
        }
        // 广告素材
        // if (key == 'ad' && data[key]) {
        //     let url = data[key];
        //     if (url.indexOf('d.ifengimg.com') == -1) {
        //         let temp = url.split('/');
        //         temp[1] = '/d.ifengimg.com/w240_h80';
        //         url = temp.join('/');
        //     }
        //     data[key] = url;
        // }
    })
    return data;
}
sportMatch.prototype.requestVote = function () {
    var _this = this;
    return $.ajax({
        url: supportGetUrl,
        type: 'get',
        cache: true,
        data: {
            surid: _this.sportMatchInfo.sid,
            rt: 'jsonp'
        },
        dataType: 'jsonp'
    })
}
sportMatch.prototype.requestData = function () {
    var _this = this;
    return $.ajax({
        url: requestUrl,
        type: 'GET',
        data: {
            mid: _this.info.matchId,
            rt: 'jsonp'
        },
        cache: true,
        dataType: 'jsonp'
    });
};
sportMatch.prototype.appendChild = function (parentNode) {
    if ($(this.el)[0]) {
        if (document.getElementsByClassName('top-box').length) {
            parentNode.parentNode.removeChild(document.getElementsByClassName('top-box')[0]);
        }
        parentNode.parentNode.insertBefore($(this.el)[0], parentNode.nextSibling);
    }
}
sportMatch.prototype.initDom = function () {
    this.el = $(tmpl({}));
    this.appendChild(this.container);
    // return {};
}
sportMatch.prototype.renderTo = function (parentNode) {
    var self = this;
    var request = Promise.resolve(this.initDom());
    request.then(() => self.requestData())
        .then(function (result) {
            if (result && result.code == 0) {
                let data = result.data;
                // console.log('renderto--', data);
                // 获取比赛信息，先渲染
                self.sportMatchInfo = data;
                data = self.formatData(data);
                // console.log('self----', self.el, self.el.find('.match-info'));
                self.el.find('.match-info').html($(tmplMatchInfo({ data: data })));
                self.el.find('.match-support').html($(tmplSupport({ data: data })));
                // 只初始化一次事件方法
                !self.initEventSta && self.initEvent();
                return data;
            } else {
                alert(result.message);
            }
        }).then(() => self.requestVote())
        .then(function (data) {
            if (data && data.code == 0) {
                // 初始化，记录
                const resultArray = data.data.resultArray;
                self.qid = resultArray.questionid;
                self.el.find('.ht').attr('data-itemid', resultArray.option[0].itemid || '');
                self.el.find('.vt').attr('data-itemid', resultArray.option[1].itemid || '');
                // 更新投票数
                self.updateVoteNum(data);
            } else {
                throw new Error(data.message);
            }

        }).catch(function (e) {
            console.log('e', e);
        });

};
sportMatch.prototype.setTimeForVote = function () {
    clearTimeout(this.timerForSupport);
    this.timerForSupport = setTimeout(function () {
        var parentNode = document.querySelector('.support-actions');
        parentNode && this.updateVote('requestVote', {}, true);
    }.bind(this), 240000); // 4min
}
sportMatch.prototype.initEvent = function () {
    this.initEventSta = true;
    var self = this;
    // 监听比分率
    this.message.on('livesports', '201', this.changeScore.bind(this));
    // 轮询获取支持率
    this.setTimeForVote();

    // 投票--点击
    $(document).on('touchend', '.ht-support', function () {
        // 样式改变,并提交
        const postParams = {
            surid: self.sportMatchInfo.sid,
            qid: self.qid,
            itemid: $(this).closest('.actions').attr('data-itemid') || '',
            rt: 'jsonp'
        };
        if (!$(this).hasClass('ht-support-success')) {
            $(this).addClass('ht-support-success');
            self.updateVote('postVote', postParams);
        }
    })
    $(document).on('touchend', '.vt-support', function () {
        // 样式改变,并提交
        const postParams = {
            surid: self.sportMatchInfo.sid,
            qid: self.qid,
            itemid: $(this).closest('.actions').attr('data-itemid') || '',
            rt: 'jsonp'
        };
        if (!$(this).hasClass('vt-support-success')) {
            $(this).addClass('vt-support-success');
            self.updateVote('postVote', postParams);
        }
    })
}
sportMatch.prototype.clearSpoll = function (timer) {
    clearTimeout(timer);
}
module.exports = sportMatch;



// WEBPACK FOOTER //
// ./app/modules/sportMatch/index.js